import React from 'react';
import ResponsiveImage from '@/components/ResponsiveImage';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const HERO_IMAGE = "https://base44.app/api/apps/691da83d30e4689f56b0df07/files/mp/public/691da83d30e4689f56b0df07/dfd08830f_ce7398770_1fa8ed3bd_Gemini_Generated_Image_1gpypm1gpypm1gpy_optimized_45.jpeg";

export default function PowerfuelHero() {
  return (
    <section className="relative overflow-hidden text-white">
      <ResponsiveImage src={HERO_IMAGE} alt="" loading="eager" fetchPriority="high" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(8,20,18,0.15) 0%, rgba(8,20,18,0.60) 50%, rgba(8,20,18,0.90) 100%)' }} />
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-[#F8F8F8]" />

      <div className="relative z-10 container mx-auto px-6 py-20 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <img
              src="https://base44.app/api/apps/691da83d30e4689f56b0df07/files/mp/public/691da83d30e4689f56b0df07/bd6429da0_400b519fb_548017b19_Enkel_LOGO-39_optimized_10.png"
              alt="enkel energi"
              className="h-20 md:h-28 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1) drop-shadow(0 0 15px rgba(255,255,255,0.7)) drop-shadow(0 0 30px rgba(255,255,255,0.4))' }}
            />
          </div>

          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 text-white px-4 py-2 rounded-full mb-6">
            <span className="bg-[#eab308] text-[#1a2e1a] text-xs font-bold px-2 py-0.5 rounded-full">POWERFUEL-KUNDE</span>
            <span className="text-sm font-medium">Din strøm fortsætter – uden afbrydelse</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4" style={{ fontFamily: '"Playfair Display", Georgia, serif', textShadow: '0 0 20px rgba(255,255,255,0.5), 0 0 40px rgba(255,255,255,0.3)' }}>
            Velkommen til enkel energi
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold mb-6 text-gray-300" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
            Powerfuel kan ikke længere levere strøm. Du er automatisk flyttet til os – og du er landet hos et elselskab, der er bygget til elbil-ejere.
          </h2>

          <p className="text-base md:text-lg text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
            Energinet har via DataHub fordelt Powerfuels kunder til nye elhandelsvirksomheder. Har du fået besked om, at
            <strong className="text-white"> enkel energi er din nye elleverandør</strong>, fortsætter din strøm helt som normalt –
            du skal ikke gøre noget. Nedenfor kan du se <strong className="text-white">hvad der er sket, hvilken aftale du er placeret på,
            dine rettigheder</strong> – og de <strong className="text-white">EV-fordele</strong>, du kan få gratis oven i.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
            {['Strømmen kører uafbrudt', 'Ingen aconto', 'Ingen binding', 'Gratis EV-fordele'].map((text, i) => (
              <div key={i} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <Check className="w-4 h-4 text-[#eab308]" />
                <span className="text-sm text-white font-medium">{text}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            <Button
              size="lg"
              className="bg-[#eab308] hover:bg-[#ca9a06] text-gray-900 font-semibold transition-all"
              onClick={() => document.getElementById('powerfuel-flow')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Se hvad der er sket <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-white/10 border-white/40 text-white hover:bg-white/20 font-semibold"
              onClick={() => document.getElementById('powerfuel-ev')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Se dine EV-fordele
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}